function prepareFAQDropdown() {
    const menuContainer = document.querySelector(".faq-container .faq-menu");
    const menuSelected = menuContainer?.querySelector(".faq-menu__selected");

    menuContainer?.classList.remove("hide");
    menuSelected?.addEventListener("click", () => {
        menuContainer?.classList.toggle("open");
    });
    document.addEventListener("click", (e) => {
        if (!menuContainer?.contains(e.target)) {
            menuContainer?.classList.remove("open");
        }
    });
}
function selectFAQElement(id) {
    const categories = document.querySelectorAll('.faq-container .faq-category');
    const newButton = document.querySelector(`.faq-menu__item[data-target="faq-${id}"]`);
    const prevButton = document.querySelector('.faq-menu__item.selected');
    const selectedValue = document.querySelector('.faq-menu .faq-menu__selected .text');

    if (newButton && categories) {
        if (prevButton) {
            if (prevButton != newButton) {
                prevButton.classList.remove('selected');
                newButton.classList.add('selected');
            }
        } else {
            newButton.classList.add('selected');
        }
        categories.forEach((el) => {
        if (el.id == `faq-${id}`) {
            el.classList.add('selected');
        } else {
            el.classList.remove('selected');
        }
        });
    }
    if (selectedValue && window.innerWidth < 1024) {
        selectedValue.innerText = newButton.innerText;
    }
}
function handleRedirection() {
    const params = new URLSearchParams(window.location.search);
    var urlId;
    var blockElement;
    var blockId;

    if (params.has('id')) {
        urlId = params.get('id');
    }
    if (urlId) {
        blockElement = document.querySelector(`.faq-container .shopify-block .faq-category[data-anchor="${urlId}"]`);
    } else {
        blockElement = document.querySelector(`.faq-container .shopify-block:first-child .faq-category`);
    }
    blockId = blockElement?.getAttribute("data-block-id");
    selectFAQElement(blockId);
}
document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 1024) {
        prepareFAQDropdown();
    }
    handleRedirection();
});